import { getFeatureSwitchStatic } from '../utils/general';

export const PRINT_LABEL_MINIMUM_VERSION = {
  iOS:
    (getFeatureSwitchStatic('iOSPrintLabelVersion', false) as string) ||
    '7.34.0',
  Android:
    (getFeatureSwitchStatic('AndroidPrintLabelVersion', false) as string) ||
    '7.34.0',
};

export const isScheduledPickupEnabled = () =>
  getFeatureSwitchStatic('isScheduledPickupEnabled', true, false);
